import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
